import * as React from 'react';
import {
  Container,
} from '@mui/material';
import Empresas from './Empresas';
import Usuarios from './Usuarios';


const GestaoEmpresasUsuarios = () => {

  return (
    <Container maxWidth="false">
      <Usuarios />
      <Empresas />
    </Container>
  );
};

export default GestaoEmpresasUsuarios;
